﻿$.fn.dxCtrlContentSondageSaisiePage = function custom_dxCtrlContentSondageSaisiePage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagesaisiepage dx-ctrl");
        this.createInstance(new cdxCtrlContentSondageSaisiePage(this, option));
    }
    return this;
}

window.cdxCtrlContentSondageSaisiePage = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        option.dataPage.lst_question.forEach(function (question) {
            mConstruitQuestion(question)
        })
    }

    var lstQuestionDivData = []
    var lstDivReponse = []
    var lstDivIntro = []
    var lstDivError = []
    var lstrCtrlQuestion = []
    function mConstruitQuestion(question) {
        var value = option.sondageReponse.mGetValueReponse(option.dataPage.id_page, question.id_question)
        var $DivQuestion = $("<div style='border-left:3px solid transparent;padding-left:3px;'/>").appendTo(container)
        lstDivReponse[question.id_question] = $DivQuestion
        lstQuestionDivData.push({
            question: question,
            div: $DivQuestion
        })
        if (!option.sondageReponse.hasReponseOuiNonActive(question)) $DivQuestion.hide()
        var $DivIntro = $("<div style='margin:15px 0 0 0;font-weight:bold;'/>").appendTo($DivQuestion)
        $DivIntro.html(question.text_intro)
        lstDivIntro[question.id_question] = $DivIntro
        var $DivError = $("<div style='color:red'/>").appendTo($DivQuestion).text("")
        lstDivError[question.id_question] = $DivError

        switch (question.type) {
            case "ouinon":
                var dx = $("<div/>").appendTo($DivQuestion).dxCtrlRadioButton({
                    dataSource: ["OUI", "NON"],
                    value: (!value ? null : (value ? "OUI" : "NON")),
                    onValueChanged: function (e) {
                        option.sondageReponse.mCreateUpdateReponse(option.dataPage.id_page, question.id_question, e.value == "OUI")
                        mUpdate()
                        $DivQuestion.css("background-color", "")
                        $DivQuestion.css("border-left", "3px solid transparent")
                        $DivError.text("")
                    }
                }).dxCtrlRadioButton("instance")
                lstrCtrlQuestion[question.id_question] = dx
                break;
            case "chk":
                var lstPhrase = JSON.parse(JSON.stringify(question.lst_phrase))
                if (!value) value = []
                mSort()
                var dxLstChk = $("<div/>").appendTo($DivQuestion).dxCtrlLstCheckBox({
                    dataSource: lstPhrase,
                    value: lstPhrase.filter(function (o) { return value.contains(o.id_phrase) }),
                    layout: (question.presentation == "horizontale" ? 'horizontal' : "vertical"),
                    itemTemplate: function (itemData, itemElement, dxChk) {
                        if (question.order_reponse) {
                            if (value.contains(itemData.id_phrase)) {
                                itemElement.html("<b style='font-size:120%;font-family:barlow condensed;'>Choix N°" + (value.indexOf(itemData.id_phrase) + 1) + ":</b> " + itemData.txt)
                            } else {
                                itemElement.text(itemData.txt)
                            }
                        } else { itemElement.text(itemData.txt) }
                        if (question.nb_max > 0 && value.length >= question.nb_max) {
                            if (!value.contains(itemData.id_phrase)) {
                                dxChk.option("disabled", true)
                                itemElement.css("opacity", "0.3")
                            }
                        }
                    },
                    onValueChanged: function (e) {
                        const anciensIds = new Set(value);
                        const ajoute = e.value.find(x => !anciensIds.has(x.id_phrase));

                        const nouveauxIds = new Set(e.value.map(x => x.id_phrase));
                        const supprime = value.find(id => !nouveauxIds.has(id));

                        if (typeof ajoute != 'undefined') {
                            //on a ajoute
                            value.push(ajoute.id_phrase)
                        } else if (typeof supprime != 'undefined') {
                            //on a supprimé
                            value.splice(value.indexOf(supprime), 1)
                        }
                        option.sondageReponse.mCreateUpdateReponse(option.dataPage.id_page, question.id_question, value)
                        if (question.order_reponse) {
                            mSort()
                            dxLstChk.mReload(lstPhrase, lstPhrase.filter(function (o) { return value.contains(o.id_phrase) }))
                        }
                        $DivQuestion.css("background-color", "")
                        $DivQuestion.css("border-left", "3px solid transparent")
                        $DivError.text("")
                    }
                }).dxCtrlLstCheckBox("instance")
                lstrCtrlQuestion[question.id_question] = dxLstChk

                function mSort() {
                    if (question.order_reponse) {
                        lstPhrase = JSON.parse(JSON.stringify(question.lst_phrase))
                        lstPhrase.forEach(function (phrase) {
                            phrase.tri = 999
                            if (value.contains(phrase.id_phrase)) phrase.tri = value.indexOf(phrase.id_phrase)
                        })
                        lstPhrase = lstPhrase.sort(function (o1, o2) { return o1.tri - o2.tri })
                    }
                }
                break;
            case "radio":
                var dx = $("<div/>").appendTo($DivQuestion).dxRadioGroup({
                    items: question.lst_phrase,
                    value: (value ? null : question.lst_phrase.filter(function (o) { return o.id_phrase == value })[0]),
                    layout: (question.presentation == "horizontale" ? 'horizontal' : "vertical"),
                    itemTemplate: (itemData, _, itemElement) => {
                        itemElement.text(itemData.txt);
                    },
                    onValueChanged: function (e) {
                        value = e.value.id_phrase
                        option.sondageReponse.mCreateUpdateReponse(option.dataPage.id_page, question.id_question, value)
                        $DivQuestion.css("background-color", "")
                        $DivQuestion.css("border-left", "3px solid transparent")
                        $DivError.text("")
                    }
                }).dxRadioGroup("instance");
                lstrCtrlQuestion[question.id_question] = dx
                break;
            case "text":
                break;
            case "textbox":
                var dx = $("<div class='barlow'/>").appendTo($DivQuestion).dxTextArea({
                    labelMode: "floating",
                    label: (question.saisie_obligatoire ? "Obligatoire" : "Facultatif"),
                    text: "",
                    value: (!value ? "" : value),
                    onValueChanged: function (e) {
                        option.sondageReponse.mCreateUpdateReponse(option.dataPage.id_page, question.id_question, (!e.value ? "" : e.value))
                        $DivQuestion.css("background-color", "")
                        $DivQuestion.css("border-left", "3px solid transparent")
                        $DivError.text("")
                    }
                }).dxTextArea("instance")
                lstrCtrlQuestion[question.id_question] = dx
                break;
        }
    }

    function mUpdate() {
        option.dataPage.lst_question.forEach(function (question) {
            var $DivQuestion = lstDivReponse[question.id_question]
            if (option.sondageReponse.hasReponseOuiNonActive(question)) { $DivQuestion.slideDown(200) }
            else { $DivQuestion.slideUp(200) }
        })
    }

    this.title = function () {
        return option.dataPage.titre
    }

    this.afficheTitle = function () {
        return option.dataPage.affiche_titre
    }

    this.isOkForNext = function (dxScroll) {
        var okForNext = true
        var firstCtrlFocus = null
        var firstElementScroll = null
        option.dataPage.lst_question.forEach(function (question) {
            lstDivReponse[question.id_question].css("border-left", "")
            var value = option.sondageReponse.mGetValueReponse(option.dataPage.id_page, question.id_question)
            switch (question.type) {
                case "ouinon":
                    if (value == null || typeof value == 'undefined') {
                        //lstDivReponse[question.id_question].css("background-color", "#ffb3b3")
                        lstDivReponse[question.id_question].css("border-left", "3px solid red")
                        lstDivReponse[question.id_question].addClass("jiggle").css("animation-duration", "0.12s");
                        window.setTimeout(function () { lstDivReponse[question.id_question].removeClass("jiggle").css("animation-duration", ""); }, 500)
                        okForNext = false
                        lstDivError[question.id_question].text("Veuillez répondre par oui ou par non...")
                        if (!firstCtrlFocus) firstCtrlFocus = lstrCtrlQuestion[question.id_question]
                        if (!firstElementScroll) firstElementScroll = lstDivReponse[question.id_question]
                    }
                    break;
                case "chk":
                    if (option.sondageReponse.hasReponseOuiNonActive(question)) {
                        if (!value) value = []
                        if (question.nb_min > 0 && value.length < question.nb_min) {
                            //lstDivReponse[question.id_question].css("background-color", "#ffb3b3")
                            lstDivReponse[question.id_question].css("border-left", "3px solid red")
                            lstDivReponse[question.id_question].addClass("jiggle").css("animation-duration", "0.12s");
                            window.setTimeout(function () { lstDivReponse[question.id_question].removeClass("jiggle").css("animation-duration", ""); }, 500)
                            okForNext = false
                            lstDivError[question.id_question].text("Veuillez sélectionner au moins " + question.nb_min + " propositions...")
                            if (!firstCtrlFocus) firstCtrlFocus = lstrCtrlQuestion[question.id_question]
                            if (!firstElementScroll) firstElementScroll = lstDivReponse[question.id_question]
                        }
                    }
                    break;
                case "radio":
                    if (option.sondageReponse.hasReponseOuiNonActive(question)) {
                        if (value == null || typeof value == 'undefined') {
                            //lstDivReponse[question.id_question].css("background-color", "#ffb3b3")
                            lstDivReponse[question.id_question].css("border-left", "3px solid red")
                            lstDivReponse[question.id_question].addClass("jiggle").css("animation-duration", "0.12s");
                            window.setTimeout(function () { lstDivReponse[question.id_question].removeClass("jiggle").css("animation-duration", ""); }, 500)
                            okForNext = false
                            lstDivError[question.id_question].text("Veuillez choisir une option...")
                            if (!firstCtrlFocus) firstCtrlFocus = lstrCtrlQuestion[question.id_question]
                            if (!firstElementScroll) firstElementScroll = lstDivReponse[question.id_question]
                        }
                    }
                    break;
                case "text":
                    break;
                case "textbox":
                    if (option.sondageReponse.hasReponseOuiNonActive(question)) {
                        if ((value == null || typeof value == 'undefined' || value.length == 0) && question.saisie_obligatoire) {
                            //lstDivReponse[question.id_question].css("background-color", "#ffb3b3")
                            lstDivReponse[question.id_question].css("border-left", "3px solid red")
                            lstDivReponse[question.id_question].addClass("jiggle").css("animation-duration", "0.12s");
                            window.setTimeout(function () { lstDivReponse[question.id_question].removeClass("jiggle").css("animation-duration", ""); }, 500)
                            okForNext = false
                            lstDivError[question.id_question].text("Veuillez saisir une réponse...")
                            if (!firstCtrlFocus) firstCtrlFocus = lstrCtrlQuestion[question.id_question]
                            if (!firstElementScroll) firstElementScroll = lstDivReponse[question.id_question]
                        }
                    }
                    break;
            }
        })

        if (dxScroll && firstElementScroll) {
            //window.setTimeout(function () { dxScroll.scrollToElement(firstCtrlFocus.element()) }, 10)
            window.setTimeout(function () {
                dxScroll.smoothScrollToElement(firstElementScroll, 600, function () {
                    if (firstCtrlFocus && firstCtrlFocus.focus) firstCtrlFocus.focus()
                })
                ////console.log("dxScroll.scrollOffset(): " + JSON.stringify(dxScroll.scrollOffset()))
                //dxScroll.scrollTo(firstCtrlFocus.element())
                //if (firstCtrlFocus && firstCtrlFocus.focus) firstCtrlFocus.focus()
            }, 10)
        }

        if (!okForNext) mNotify("Veuillez répondre à l'ensemble des questions pour continuer", "error", 6000)

        return okForNext
    }

    this.mGetProprieteImage = function () {
        return {
            url: option.dataPage.link_img,
            position: option.dataPage.position_img
        }
    }

    this.mIsActivated = function () {
        //la page de saisie vient d'être affiché
        if (option.dataPage.id_page == -1) {
            //si c'est la dernière page, on finalise le reponsesondage
            if (option.sondageReponse.dataSondageReponse.finalise == "0") {
                option.sondageReponse.mCalculTauxSatisfaction(option.dataPage.id_page, true)
            }
            lstQuestionDivData.forEach(function (itemData) {
                if (typeof itemData.question.tx_satisfaction_min == 'undefined' ||
                    (typeof itemData.question.tx_satisfaction_min != 'undefined' &&
                        option.sondageReponse.dataSondageReponse.taux_satisfaction >= itemData.question.tx_satisfaction_min &&
                        option.sondageReponse.dataSondageReponse.taux_satisfaction <= itemData.question.tx_satisfaction_max)) {
                    itemData.div.show()
                } else {
                    itemData.div.hide()
                }
            })
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_sondage/id_table_dest/id_dest/id_sondage_reponse/index_page/ignore/sondage
        var page = option.sondageReponse.sondage.lstPage.filter(function (o) { return o.id_page == option.dataPage.id_page })[0]
        var idxPage = option.sondageReponse.sondage.lstPage.indexOf(page)
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            option.sondageReponse.dataSondageReponse.id_sondage + "/" +
            option.sondageReponse.dataSondageReponse.id_table_destinataire + "/" +
            option.sondageReponse.dataSondageReponse.id_destinataire + "/" +
            (option.sondageReponse.dataSondageReponse.id_sondage_reponse ? option.sondageReponse.dataSondageReponse.id_sondage_reponse : 0) + "/" +
            idxPage + "/" +
            (option.sondageReponse.dataSondageReponse.ignoreSave ? "1" : "0") + "/sondage"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_sondage/id_table_dest/id_dest/id_sondage_reponse/index_page/ignore/sondage
        //locationPathname=/nom_base/id_sondage/id_table_dest/id_dest/id_sondage_reponse/index_page/ignore/sondage
        return locationPathname.split("/")[6]
    }

    this.element = function () { return container; }
    this.component = function () { return Me; }

    mConstruit();
}